import React from "react";
import { Container, ContainerView } from "../../components/Container";
import { useApp } from "../../contexts";
import { useLocation, useNavigate } from "react-router-dom";
import { TitleWithBack } from "../../components/Layout";
import styled from "styled-components";
import { FORMAT_DATE } from "../stake-detail";
import moment from "moment";
import { MyButton } from "../../components/Button/style";
import { formatMoney } from "../../utils/hepler";
import { IconSuccess, LabelOrderDetail } from "./style";
import Footer from "../../components/Layout/footer";
import { useWindowSize } from "../../hook/useWindowSize";
const TitleInfo = styled.div`
  padding: 0 94px;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  text-align: center;
  color: #F12E11;
  @media (max-width: 768px) {
    padding: 0 27px;
  }
`;

const StakeSuccess = () => {
  const { T } = useApp();
  const navigate = useNavigate();
  const location = useLocation();
  const stake = location.state;
  const size = useWindowSize();

  const onBack = () => {
    navigate(`/stake`);
  };
  if (!stake) return null;
  return (
    <Container>
      <div className="w-[95%] max-w-[1270px] mx-auto mt-[16px] lg:mt-[56px] ">
        <TitleWithBack mb={0} title={T("Stake SGT")} onClick={onBack} />
      </div>
      <ContainerView
        style={{ maxWidth: 768, marginTop: size.width > 1024 ? 20 : 49 }}
      >
        <div className="flex justify-center">
          <IconSuccess />
        </div>
        <TitleInfo className="mt-[12px] lg:mt-[22px]">
          {T(
            "You’ve successfully requested to stake {amount} SGT! Your transaction status will be displayed in Stake."
          ).replace("{amount}", formatMoney(stake?.amount))}
        </TitleInfo>
        <div className="flex flex-col mt-[30px] lg:mt-[35px]">
          <div className="bg-[#FFFFFF] mx-auto rounded-[20px] h-[226px] pt-[24px] pl-[40px] pr-[33.5px] pb-[29px]">
            <div className="flex justify-between">
              <LabelOrderDetail>{T("Staking Term")}</LabelOrderDetail>
              <LabelOrderDetail className="text-right" color="#000000">
                {stake?.plan?.year} {T(stake?.plan?.label)}
              </LabelOrderDetail>
            </div>
            <div className="flex justify-between">
              <LabelOrderDetail>{T("Effective Date")}</LabelOrderDetail>
              <LabelOrderDetail className="text-right" color="#000000">
                {moment(stake?.timeStartStake)?.format(FORMAT_DATE)}
              </LabelOrderDetail>
            </div>
            <div className="flex justify-between">
              <LabelOrderDetail>{T("Maturity Date")}</LabelOrderDetail>
              <LabelOrderDetail className="text-right" color="#000000">
                {moment(
                  stake?.timeStartStake + stake?.plan?.duration * 1000
                )?.format(FORMAT_DATE)}
              </LabelOrderDetail>
            </div>
            <div className="flex justify-between">
              <LabelOrderDetail>{T("xSGT Voting Power")}</LabelOrderDetail>
              <LabelOrderDetail className="text-right" color="#000000">
                {formatMoney(
                  (stake?.amount * stake?.plan?.ratioGetTokenStaking) / 100
                )}
              </LabelOrderDetail>
            </div>
          </div>
          <div className="flex gap-4 mt-[50px] justify-center">
            <MyButton
              style={{ width: 250 }}
              className="confirm"
              onClick={onBack}
            >
              {T("Go to Stake")}
            </MyButton>
          </div>
        </div>
      </ContainerView>
      <Footer />
    </Container>
  );
};

export default StakeSuccess;
